import type { Logger } from "../../data-model/ports.js";

interface Closeable {
  close(): Promise<void>;
}

export async function safeClosePage(page: Closeable, logger?: Logger): Promise<void> {
  try {
    await page.close();
  } catch (err) {
    logger?.debug({ err }, "page close failed (non-fatal)");
  }
}

export async function safeCloseContext(ctx: Closeable, logger?: Logger): Promise<void> {
  try {
    await ctx.close();
  } catch (err) {
    logger?.debug({ err }, "context close failed (non-fatal)");
  }
}
